const COTTON_PATH = 'cotton';
export default COTTON_PATH;
